import { useEffect, useState } from "react";
import {
  getDepositTransaction,
  getEventTransaction,
} from "../../../api/getApi";
import NotFound from "../../../components/ProgressBlock/NotFound";
import { Box, Flex, VStack } from "@chakra-ui/react";
import RecordDashboard from "./recordDashboard";
import LoadingBetRecord from "../../../components/Loading/LoadingBetRecord";
import Paginator from "./paginator";
import EventRecordDashboard from "./eventRecordDashboard";
import { waitTime } from "../../../utils/waitTime";

const EventTransaction = ({ datePicker } = {}) => {
  const { str_date, end_date } = datePicker || {};
  const [record, setRecord] = useState([]);
  const [pagination, setPagination] = useState({
    current_page: null,
    last_page: null,
    from: null,
    to: null,
    total: null,
  });
  const [apiCalling, setApiCalling] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const fetchData = async () => {
      setApiCalling(true);
      await getEventTransaction({
        paramsData: {
          str_date,
          end_date,
          limit: 25,
          current_page: currentPage,
        },
      }).then((res) => {
        const { current_page, last_page, from, to, total, data } = res?.data;
        //   setRecord(data?.data?.data);
        setPagination({
          current_page,
          last_page,
          from,
          to,
          total,
        });
        setRecord(data);
      });
      await waitTime(1000);
      setApiCalling(false);
    };
    fetchData();
  }, [datePicker, currentPage]);

  return (
    <Flex w="100%" direction={`column`} gap={4} spacing={4}>
      <LoadingBetRecord commonLoading={apiCalling}>
        {record?.length === 0 ? (
          <NotFound />
        ) : (
          record?.map((item, index) => {
            return (
              <EventRecordDashboard
                single={index % 2 === 0}
                method={"EVENT"}
                props={item}
              />
            );
          })
        )}
      </LoadingBetRecord>
      <Box>
        <Paginator
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          pagination={pagination}
        />
      </Box>
    </Flex>
  );
};

export default EventTransaction;
